import { render } from "./icon-simpleline.vue?vue&type=template&id=645340b2"
import script from "./icon-simpleline.vue?vue&type=script&lang=js"
export * from "./icon-simpleline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__